import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          漫评解说
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          资深漫评人为你解读最热漫画，深度内容不容错过
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 max-w-6xl mx-auto">
          {mediaItems.map((item, i) => (
            <a
              key={i}
              href="#media"
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer transition-all duration-200 hover:border-accent-300"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-600"
                  loading={i === 0 ? undefined : 'lazy'}
                />
                <div className="absolute inset-0 flex items-center justify-center bg-black/10 group-hover:bg-black/20 transition-colors">
                  <div className="w-12 h-12 rounded-full bg-black/50 flex items-center justify-center group-hover:bg-accent-500 group-hover:scale-110 transition-all duration-200">
                    <i className="ri-play-fill text-white text-xl ml-0.5" />
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/60 text-white text-xs font-medium">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors line-clamp-2 mb-2.5">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500">{item.author}</span>
                  <div className="flex items-center gap-1">
                    <i className="ri-eye-line text-xs text-accent-400" />
                    <span className="text-xs text-accent-600 font-medium">{item.views} 次观看</span>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}